/**
 * Fiskehandleren Delivery V2 — Cart sidebar redesign
 * En samlet widget: pris/frakt/total + postnr + dato/tid + checkout
 */
(function () {
  'use strict';

  var API_BASE = window.__FH_DELIVERY_API || '';
  // Vipps ekspress: knappen vises KUN naar OPS sier enabled (noekler satt). 404/feil = aldri synlig.
  var vippsReady = false;
  var vippsStatusDone = false;
  var vippsCbs = [];
  function vippsStatus(cb) { if (vippsStatusDone) { try { cb(vippsReady); } catch (e) {} } else { vippsCbs.push(cb); } }
  var _vippsLibReq = false;
  function loadVippsButtonLib() {
    if (_vippsLibReq || (window.customElements && customElements.get('vipps-mobilepay-button'))) return;
    if (document.querySelector('script[data-fh-vipps-lib]')) { _vippsLibReq = true; return; }
    _vippsLibReq = true;
    var s = document.createElement('script');
    s.async = true; s.src = 'https://cdn.vippsmobilepay.com/js/button/button.js';
    s.setAttribute('data-fh-vipps-lib', '1');
    (document.head || document.documentElement).appendChild(s);
  }
  function vippsBtnHtml(verb) {
    return '<vipps-mobilepay-button brand="vipps" language="no" verb="' + verb + '" variant="primary" rounded="true" stretched="true"></vipps-mobilepay-button>';
  }
  function initVippsStatus() {
    var base = window.__FH_VIPPS_API || API_BASE;
    function resolve(v) {
      vippsReady = v; vippsStatusDone = true;
      if (v) {
        loadVippsButtonLib();
        var btns = document.querySelectorAll('[data-fh-vipps][hidden]');
        for (var i = 0; i < btns.length; i++) btns[i].hidden = false;
      }
      var cbs = vippsCbs; vippsCbs = [];
      for (var j = 0; j < cbs.length; j++) { try { cbs[j](v); } catch (e) {} }
    }
    if (!base || !window.fetch) { resolve(false); return; }
    try {
      fetch(base + '/api/vipps/status').then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        resolve(!!(d && d.enabled));
      }).catch(function () { resolve(false); });
    } catch (e) { resolve(false); }
  }
  initVippsStatus();
  var STORAGE_KEY = 'fh_delivery_v2';
  var CART_UPDATE_URL = '/cart/update.js';
  var _selfFetch = false;
  var _updateTimer = null;
  var DAY_NAMES = ['sondag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lordag'];
  var DAY_NAMES_CAP = ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'];
  var MONTH_NAMES = ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'];

  var state = loadState();

  function loadState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) { /* ignore */ }
    return { postnr: null, zone: null, nextDates: [], selectedDate: null, selectedSlot: null, slots: [], deliveryNote: '', notHome: false };
  }

  function saveState() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) { /* ignore */ }
  }

  function clearState() {
    state = { postnr: null, zone: null, nextDates: [], selectedDate: null, selectedSlot: null, slots: [], deliveryNote: '', notHome: false };
    saveState();
  }

  // ── API ────────────────────────────────────────────────────────────────────

  var _slotsReqId = 0;
  var _priceReqId = 0;

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  function safeFetch(url, opts, retries) {
    if (retries === undefined) retries = 2;
    return fetch(url, opts).then(function (r) {
      if (!r.ok) {
        if (r.status >= 500 && retries > 0) {
          return new Promise(function (resolve) { setTimeout(resolve, 1000); })
            .then(function () { return safeFetch(url, opts, retries - 1); });
        }
        throw new Error('API-feil: ' + r.status);
      }
      return r.json();
    }).catch(function (err) {
      if (err.message && err.message.indexOf('API-feil') === 0) throw err;
      if (retries > 0) {
        return new Promise(function (resolve) { setTimeout(resolve, 1000); })
          .then(function () { return safeFetch(url, opts, retries - 1); });
      }
      throw new Error('Nettverksfeil - prøv igjen');
    });
  }

  function apiCall(action, params) {
    var qs = Object.keys(params || {}).map(function (k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
    }).join('&');
    var url = API_BASE + '/api/delivery/public?action=' + action + (qs ? '&' + qs : '');
    return safeFetch(url);
  }

  function apiPostAction(action, body) {
    return safeFetch(API_BASE + '/api/delivery/public?action=' + action, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  }

  function checkPostnr(postnr) { return apiPostAction('check', { postnr: postnr }); }

  function getSlots(zoneId, date) {
    var myId = ++_slotsReqId;
    var params = { zone_id: zoneId, date: date };
    if (state.postnr) params.postnr = state.postnr;
    return apiCall('slots', params).then(function (data) {
      if (myId !== _slotsReqId) return Promise.reject('stale');
      return data;
    });
  }

  function getPrice(orderValue, slotId) {
    var myId = ++_priceReqId;
    return apiCall('price', { order_value: orderValue, slot_id: slotId }).then(function (data) {
      if (myId !== _priceReqId) return Promise.reject('stale');
      return data;
    });
  }

  // ── Date helpers ─────────────────────────────────────────────────────────────

  function parseDate(str) {
    var parts = str.split('-');
    return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
  }

  function formatDateShort(str) {
    var d = parseDate(str);
    return DAY_NAMES_CAP[d.getDay()] + ' ' + d.getDate() + '. ' + MONTH_NAMES[d.getMonth()];
  }

  function dayNameCap(str) { return DAY_NAMES_CAP[parseDate(str).getDay()]; }
  function dayNum(str) { return parseDate(str).getDate(); }
  function monthName(str) { return MONTH_NAMES[parseDate(str).getMonth()]; }

  function formatTime(timeStr) {
    if (!timeStr) return '';
    return timeStr.substring(0, 5);
  }

  // ── Cart attributes ────────────────────────────────────────────────────────

  function updateCartAttributes(attrs) {
    _selfFetch = true;
    return fetch(CART_UPDATE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    }).then(function (r) { setTimeout(function () { _selfFetch = false; }, 1000); return r.json(); })
      .catch(function (e) { setTimeout(function () { _selfFetch = false; }, 1000); throw e; });
  }

  function syncCartAttributes() {
    if (!state.postnr || !state.selectedDate || !state.selectedSlot) return Promise.resolve();
    var slot = state.slots.find(function (s) { return s.slot_id === state.selectedSlot; });
    var slotLabel = slot ? (slot.start + ' – ' + slot.end) : '';
    var attrs = {
      'Delivery-Date': state.selectedDate,
      'Delivery-Day': state.selectedDate ? DAY_NAMES[parseDate(state.selectedDate).getDay()] : '',
      'Delivery-Time': slotLabel,
      'Delivery-Zone': state.zone ? state.zone.name : '',
      'Delivery-Postnr': state.postnr,
      'Checkout-Method': 'delivery',
    };
    if (state.deliveryNote) {
      attrs['Delivery-Note'] = state.deliveryNote;
    } else if (state.notHome) {
      attrs['Delivery-Note'] = 'Ikke hjemme - legg ved døren';
    }
    return updateCartAttributes(attrs);
  }

  // ── Product page ──────────────────────────────────────────────────────────

  function initProductDelivery() {
    var els = document.querySelectorAll('.fh-dprod');
    if (!els.length) return;

    if (state.nextDates && state.nextDates.length > 0) {
      var _now = new Date();
      var _oslo = new Date(_now.toLocaleString('en-US', {timeZone: 'Europe/Oslo'}));
      var _todayStr = _oslo.getFullYear() + '-' +
        String(_oslo.getMonth()+1).padStart(2,'0') + '-' +
        String(_oslo.getDate()).padStart(2,'0');
      state.nextDates = state.nextDates.filter(function(d) { return d > _todayStr; });
      if (state.selectedDate && state.selectedDate <= _todayStr) {
        state.selectedDate = state.nextDates[0] || null;
        state.selectedSlot = null;
      }
      saveState();
    }

    els.forEach(function (el) {
      if (state.postnr && state.zone && state.nextDates.length > 0) { renderProductConfirmed(el); }
      else { renderProductPrompt(el); }
    });
  }

  function renderProductPrompt(el) {
    el.innerHTML = '';
    el.style.display = 'none';
  }

  function renderProductConfirmed(el) {
    var date = state.nextDates[0] || '';
    var cutoffDate = '';
    if (date) {
      var d = parseDate(date); d.setDate(d.getDate() - 1);
      cutoffDate = DAY_NAMES_CAP[d.getDay()] + ' kl 23:59';
    }
    el.innerHTML =
      '<div class="fh-dprod-box">' +
        '<svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>' +
        '<div class="fh-dprod-text">' +
          '<p>Leveres ' + formatDateShort(date) + ' til ' + esc(state.postnr) + '</p>' +
          (cutoffDate ? '<span class="fh-dprod-sub">Bestill innen ' + cutoffDate + '</span>' : '') +
        '</div>' +
        '<a class="fh-dprod-change" href="#">Endre</a>' +
      '</div>';
    el.querySelector('.fh-dprod-change').addEventListener('click', function (e) {
      e.preventDefault(); clearState(); renderProductPrompt(el);
    });
  }

  // ── Express pay / Hurtigkjøp (produktside) ────────────────────────────────
  // Postnr-sjekk + leveringsvalg direkte på produktsiden, deretter rett til
  // betaling (/checkout viser Vipps/kort). Gjenbruker samme state og
  // syncCartAttributes som cart-flyten, så ordren får identiske
  // leveringsattributter (Delivery-Date/Day/Time/Zone/Postnr/Checkout-Method).

  function dxTodayOslo() {
    var now = new Date();
    var oslo = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Oslo' }));
    return oslo.getFullYear() + '-' +
      String(oslo.getMonth() + 1).padStart(2, '0') + '-' +
      String(oslo.getDate()).padStart(2, '0');
  }

  function dxPruneStaleDates() {
    if (!state.nextDates || !state.nextDates.length) return;
    var todayStr = dxTodayOslo();
    state.nextDates = state.nextDates.filter(function (d) { return d > todayStr; });
    if (state.selectedDate && state.selectedDate <= todayStr) {
      state.selectedDate = state.nextDates[0] || null;
      state.selectedSlot = null;
      state.slots = [];
    }
    saveState();
  }

  function initExpressPay() {
    var mount = document.querySelector('[data-fh-express]');
    if (!mount) return;
    if (!document.getElementById('fhp-variant-id')) return;
    dxPruneStaleDates();
    // Vipps ekspress er standard hurtiglinjen paa produktsiden. Faller tilbake til det gamle
    // Hurtigkjoep-panelet (-> /checkout) KUN hvis Vipps er slaatt av (OPS kill-switch).
    if (vippsStatusDone && !vippsReady) { dxRenderToggle(mount); return; }
    renderVippsTrigger(mount);
    vippsStatus(function (enabled) { if (!enabled) dxRenderToggle(mount); });
  }

  function renderVippsTrigger(mount) {
    loadVippsButtonLib();
    mount.innerHTML =
      '<div class="fhp__vexp" data-fh-vexp>' + vippsBtnHtml('continue') + '</div>' +
      '<p class="fhp__vexp-hint">Velg leveringsdag og betal trygt med Vipps</p>';
    mount.querySelector('.fhp__vexp').addEventListener('click', function (e) {
      e.preventDefault();
      openVippsModal();
    });
    // Fallback hvis Vipps-web-komponenten ikke rekker aa laste (CDN blokkert):
    setTimeout(function () {
      var wrap = mount.querySelector('.fhp__vexp');
      if (!wrap) return;
      var wc = wrap.querySelector('vipps-mobilepay-button');
      var defined = window.customElements && customElements.get('vipps-mobilepay-button');
      if (defined && wc && wc.offsetHeight > 0) return;
      wrap.innerHTML = '<button type="button" class="fh-dx-vipps-native">Fortsett med Vipps</button>';
    }, 2600);
  }

  function vippsEsc(e) { if (e.key === 'Escape') closeVippsModal(); }
  function closeVippsModal() {
    var m = document.querySelector('.fhv-modal');
    if (m && m.parentNode) m.parentNode.removeChild(m);
    document.removeEventListener('keydown', vippsEsc);
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  function openVippsModal() {
    if (document.querySelector('.fhv-modal')) return;
    loadVippsButtonLib();
    var m = document.createElement('div');
    m.className = 'fhv-modal';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-label', 'Velg levering og betal med Vipps');
    m.innerHTML =
      '<div class="fhv-modal__backdrop" data-fhv-close></div>' +
      '<div class="fhv-modal__card" role="document">' +
        '<div class="fhv-modal__head">' +
          '<span>Velg levering</span>' +
          '<button type="button" class="fhv-modal__close" data-fhv-close aria-label="Lukk">Lukk</button>' +
        '</div>' +
        '<div class="fh-dx-body"></div>' +
        '<div class="fh-dx-foot fhv-modal__foot">' +
          '<div class="fhv-cta" data-fhv-pay hidden>' + vippsBtnHtml('pay') + '</div>' +
          '<p class="fhv-cta-wait">Velg dag og tid, så kan du betale med Vipps</p>' +
          '<p class="fh-dx-err" hidden></p>' +
        '</div>' +
      '</div>';
    document.body.appendChild(m);
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    var card = m.querySelector('.fhv-modal__card');
    var closers = m.querySelectorAll('[data-fhv-close]');
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', closeVippsModal);
    document.addEventListener('keydown', vippsEsc);
    m.addEventListener('click', function (e) {
      if (e.target.closest('.fhv-cta')) { e.preventDefault(); dxVippsNow(card); }
    });
    var body = card.querySelector('.fh-dx-body');
    if (state.postnr) {
      body.innerHTML = '<p class="fh-dx-msg">Henter leveringsdager...</p>';
      checkPostnr(state.postnr).then(function (data) {
        if (data.available && data.next_dates && data.next_dates.length) {
          state.zone = data.zone;
          state.nextDates = data.next_dates;
          if (!state.selectedDate || state.nextDates.indexOf(state.selectedDate) === -1) {
            state.selectedDate = state.nextDates[0]; state.selectedSlot = null; state.slots = [];
          }
          saveState();
          dxRenderDelivery(card);
        } else { dxRenderPostnr(card); }
      }).catch(function () {
        if (state.zone && state.nextDates && state.nextDates.length) dxRenderDelivery(card);
        else dxRenderPostnr(card);
      });
    } else {
      dxRenderPostnr(card);
    }
  }

  // FH 2026-08-26: hurtigkjoep skal ALDRI plusse paa en eksisterende kurvlinje.
  // /cart/add.js er additivt — gjentatte kjoepsforsoek doblet antallet (kundesak
  // Steinbitkaker 26.8). Naa: finnes varianten alt i kurven, settes antallet til
  // max(eksisterende, valgt) via /cart/change.js — idempotent ved retry.
  function expressPutInCart(variantId, qty) {
    // Feil med .fhUser=true har kundevendt norsk tekst fra Shopify (f.eks.
    // lager-melding); alt annet vises som generisk norsk melding.
    function userErr(msg) { var e = new Error(msg); e.fhUser = true; return e; }
    function chk(r) {
      if (!r.ok) {
        return r.json().then(function (j) {
          throw (j && j.description) ? userErr(j.description) : new Error('ADD_FAILED');
        }, function () { throw new Error('ADD_FAILED'); });
      }
      return r.json();
    }
    // Ren linje = uten line item properties / selling plan (Simple Bundles
    // lager komponentlinjer med properties — de skal ALDRI roeres her).
    function cleanLine(it) {
      if (it.selling_plan_allocation) return false;
      if (it.properties && Object.keys(it.properties).length > 0) return false;
      return true;
    }
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id === variantId && cleanLine(cart.items[i])) { line = cart.items[i]; break; }
      }
      if (line) {
        var target = Math.max(line.quantity, qty);
        if (target === line.quantity) return cart;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: target }),
        }).then(chk).then(function (updated) {
          // change.js klipper STILLE til maks lager (i motsetning til add.js
          // som gir 422) — verifiser at antallet faktisk ble satt.
          var after = null;
          for (var k = 0; k < updated.items.length; k++) {
            if (updated.items[k].key === line.key || updated.items[k].variant_id === variantId) { after = updated.items[k]; break; }
          }
          if (!after || after.quantity < target) {
            throw userErr('Det er ikke nok på lager til å øke antallet. Juster antallet i handlekurven.');
          }
          return updated;
        });
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty }),
      }).then(chk);
    });
  }

  var dxVippsInFlight = false;

  function dxVippsNow(mount) {
    if (dxVippsInFlight) return;
    if (!dxStateComplete()) { dxErr(mount, 'Velg dag og tid først.'); return; }
    var variantInput = document.getElementById('fhp-variant-id');
    var qtyInput = document.getElementById('fhp-qty');
    var variantId = variantInput ? parseInt(variantInput.value, 10) : 0;
    if (!variantId) { dxErr(mount, 'Velg en størrelse først.'); return; }
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    dxErr(mount, null);
    dxVippsInFlight = true;
    var wait = mount.querySelector('.fhv-cta-wait');
    if (wait) { wait.textContent = 'Sender deg til Vipps...'; wait.hidden = false; }
    var ctaWrap = mount.querySelector('.fhv-cta');
    if (ctaWrap) ctaWrap.style.pointerEvents = 'none';
    expressPutInCart(variantId, qty).then(function () {
      var base = window.__FH_VIPPS_API || API_BASE;
      var url = base + '/api/vipps/start?postnr=' + encodeURIComponent(state.postnr || '');
      var navigated = false;
      function go() { if (navigated) return; navigated = true; window.location.href = url; }
      syncCartAttributes().then(go).catch(go);
      setTimeout(go, 1800);
    }).catch(function (e) {
      dxVippsInFlight = false;
      if (ctaWrap) ctaWrap.style.pointerEvents = '';
      if (wait) wait.hidden = true;
      var msg = (e && e.fhUser && e.message) ? e.message : 'Fikk ikke lagt varen i handlekurven. Prøv igjen.';
      dxErr(mount, msg);
    });
  }

  function dxRenderToggle(mount) {
    mount.innerHTML =
      '<button type="button" class="fh-dx-toggle">' +
        '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>' +
        '<span>Hurtigkjøp</span>' +
      '</button>';
    mount.querySelector('.fh-dx-toggle').addEventListener('click', function () {
      dxRenderPanel(mount);
    });
  }

  function dxStateComplete() {
    return !!(state.postnr && state.zone && state.selectedDate && state.selectedSlot &&
      state.slots && state.slots.some(function (s) { return s.slot_id === state.selectedSlot && s.available > 0; }));
  }

  function dxRenderPanel(mount) {
    mount.innerHTML =
      '<div class="fh-dx-panel">' +
        '<div class="fh-dx-head">' +
          '<span>Hurtigkjøp</span>' +
          '<button type="button" class="fh-dx-close" aria-label="Lukk">Lukk</button>' +
        '</div>' +
        '<div class="fh-dx-body"></div>' +
        '<div class="fh-dx-foot">' +
          '<button type="button" class="fh-dx-cta" disabled>Til betaling</button>' +
          '<p class="fh-dx-hint">Vipps, Apple Pay, Google Pay eller kort i neste steg</p>' +
          '<p class="fh-dx-err" hidden></p>' +
        '</div>' +
      '</div>';
    mount.querySelector('.fh-dx-close').addEventListener('click', function () { dxRenderToggle(mount); });
    mount.querySelector('.fh-dx-cta').addEventListener('click', function () { dxBuyNow(mount); });
    if (state.postnr) {
      var body = mount.querySelector('.fh-dx-body');
      body.innerHTML = '<p class="fh-dx-msg">Henter leveringsdager...</p>';
      checkPostnr(state.postnr).then(function (data) {
        if (data.available && data.next_dates && data.next_dates.length) {
          state.zone = data.zone;
          state.nextDates = data.next_dates;
          if (!state.selectedDate || state.nextDates.indexOf(state.selectedDate) === -1) {
            state.selectedDate = state.nextDates[0];
            state.selectedSlot = null;
            state.slots = [];
          }
          saveState();
          dxRenderDelivery(mount);
        } else {
          dxRenderPostnr(mount);
        }
      }).catch(function () {
        if (state.zone && state.nextDates && state.nextDates.length) dxRenderDelivery(mount);
        else dxRenderPostnr(mount);
      });
    } else {
      dxRenderPostnr(mount);
    }
  }

  function dxErr(mount, msg) {
    var el = mount.querySelector('.fh-dx-err');
    if (!el) return;
    if (msg) { el.textContent = msg; el.hidden = false; }
    else { el.hidden = true; }
  }

  function dxSetCta(mount, ready, label) {
    var cta = mount.querySelector('.fh-dx-cta');
    if (cta) { cta.disabled = !ready; cta.textContent = label || 'Til betaling'; }
    var vcta = mount.querySelector('.fhv-cta');
    if (vcta) vcta.hidden = !ready;
    var vwait = mount.querySelector('.fhv-cta-wait');
    if (vwait) vwait.hidden = !!ready;
  }

  function dxRenderPostnr(mount) {
    var body = mount.querySelector('.fh-dx-body');
    dxSetCta(mount, false);
    body.innerHTML =
      '<p class="fh-dx-label">Hvor skal vi levere?</p>' +
      '<div class="fh-dx-postnr">' +
        '<input type="text" class="fh-dx-postnr-input" placeholder="Postnummer" maxlength="4" inputmode="numeric" pattern="[0-9]*" autocomplete="postal-code">' +
        '<button type="button" class="fh-dx-postnr-btn">Sjekk</button>' +
      '</div>' +
      '<p class="fh-dx-msg"></p>';
    var input = body.querySelector('.fh-dx-postnr-input');
    var btn = body.querySelector('.fh-dx-postnr-btn');
    var msg = body.querySelector('.fh-dx-msg');
    if (state.postnr) input.value = state.postnr;
    function check() {
      var val = (input.value || '').trim().replace(/\s/g, '').padStart(4, '0');
      if (val.length !== 4 || !/^\d{4}$/.test(val)) {
        msg.textContent = 'Skriv inn et gyldig postnummer';
        msg.className = 'fh-dx-msg fh-dx-msg--err';
        return;
      }
      btn.disabled = true;
      msg.textContent = 'Sjekker postnummer...';
      msg.className = 'fh-dx-msg';
      checkPostnr(val).then(function (data) {
        btn.disabled = false;
        if (data.available && data.next_dates && data.next_dates.length) {
          state.postnr = val;
          state.zone = data.zone;
          state.nextDates = data.next_dates;
          state.selectedDate = state.nextDates[0] || null;
          state.selectedSlot = null;
          state.slots = [];
          saveState();
          dxRenderDelivery(mount);
        } else if (data.available) {
          msg.textContent = 'Vi har ingen ledige leveringsdager til ' + val + ' akkurat nå';
          msg.className = 'fh-dx-msg fh-dx-msg--err';
        } else {
          msg.textContent = 'Vi leverer dessverre ikke til ' + val + ' ennå';
          msg.className = 'fh-dx-msg fh-dx-msg--err';
        }
      }).catch(function () {
        btn.disabled = false;
        msg.textContent = 'Noe gikk galt. Prøv igjen.';
        msg.className = 'fh-dx-msg fh-dx-msg--err';
      });
    }
    btn.addEventListener('click', check);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); check(); }
    });
    input.focus();
  }

  function dxRenderDelivery(mount) {
    var body = mount.querySelector('.fh-dx-body');
    if (!state.nextDates || !state.nextDates.length) { dxRenderPostnr(mount); return; }
    if (!state.selectedDate || state.nextDates.indexOf(state.selectedDate) === -1) {
      state.selectedDate = state.nextDates[0];
      state.selectedSlot = null;
      state.slots = [];
      saveState();
    }
    var dates = state.nextDates.slice(0, 6);
    var dateHtml = dates.map(function (d) {
      var sel = (state.selectedDate === d) ? ' fh-dx-date--sel' : '';
      return '<button type="button" class="fh-dx-date' + sel + '" data-date="' + d + '">' +
        '<span class="fh-dx-date-day">' + dayNameCap(d) + '</span>' +
        '<span class="fh-dx-date-rest">' + dayNum(d) + '. ' + monthName(d) + '</span>' +
      '</button>';
    }).join('');
    body.innerHTML =
      '<div class="fh-dx-where">' +
        '<span>Leveres til <strong>' + esc(state.postnr) + '</strong></span>' +
        '<button type="button" class="fh-dx-change">Endre</button>' +
      '</div>' +
      '<p class="fh-dx-label">Velg dag</p>' +
      '<div class="fh-dx-dates">' + dateHtml + '</div>' +
      '<div class="fh-dx-slots"></div>';
    body.querySelector('.fh-dx-change').addEventListener('click', function () {
      dxRenderPostnr(mount);
    });
    body.querySelectorAll('.fh-dx-date').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.selectedDate = btn.dataset.date;
        state.selectedSlot = null;
        state.slots = [];
        saveState();
        body.querySelectorAll('.fh-dx-date').forEach(function (b) { b.classList.remove('fh-dx-date--sel'); });
        btn.classList.add('fh-dx-date--sel');
        dxLoadSlots(mount);
      });
    });
    dxLoadSlots(mount);
  }

  function dxLoadSlots(mount) {
    var container = mount.querySelector('.fh-dx-slots');
    if (!container || !state.zone || !state.selectedDate) return;
    dxSetCta(mount, false);
    container.innerHTML = '<p class="fh-dx-msg">Henter tidsvinduer...</p>';
    getSlots(state.zone.id, state.selectedDate).then(function (data) {
      var slots = data.slots || [];
      state.slots = slots;
      var open = slots.filter(function (s) { return s.available > 0; });
      if (!open.length) {
        state.selectedSlot = null;
        saveState();
        container.innerHTML = '<p class="fh-dx-msg fh-dx-msg--err">Ingen ledige tidsvinduer denne dagen. Velg en annen dag.</p>';
        return;
      }
      var stillValid = open.some(function (s) { return s.slot_id === state.selectedSlot; });
      if (!stillValid) {
        var rec = open.filter(function (s) { return s.recommended; });
        state.selectedSlot = (rec[0] || open[0]).slot_id;
      }
      saveState();
      container.innerHTML = '<p class="fh-dx-label">Tidsvindu</p>' + slots.map(function (s) {
        var sel = (state.selectedSlot === s.slot_id) ? ' fh-dx-slot--sel' : '';
        var full = s.available === 0;
        var cap = full ? '<span class="fh-dx-slot-cap">Fullt</span>'
          : (s.available <= 3 ? '<span class="fh-dx-slot-cap">Kun ' + s.available + ' igjen</span>' : '');
        return '<button type="button" class="fh-dx-slot' + sel + '" data-slot="' + s.slot_id + '"' + (full ? ' disabled' : '') + '>' +
          '<span class="fh-dx-slot-radio"></span>' +
          '<span class="fh-dx-slot-time">' + formatTime(s.start) + ' – ' + formatTime(s.end) + '</span>' +
          cap +
        '</button>';
      }).join('');
      container.querySelectorAll('.fh-dx-slot:not([disabled])').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.selectedSlot = parseInt(btn.dataset.slot, 10);
          saveState();
          container.querySelectorAll('.fh-dx-slot').forEach(function (b) { b.classList.remove('fh-dx-slot--sel'); });
          btn.classList.add('fh-dx-slot--sel');
          syncCartAttributes().catch(function () {});
        });
      });
      syncCartAttributes().catch(function () {});
      dxSetCta(mount, true);
    }).catch(function (err) {
      if (err === 'stale') return;
      container.innerHTML = '<p class="fh-dx-msg fh-dx-msg--err">Kunne ikke hente tidsvinduer. Prøv igjen.</p>';
    });
  }

  function dxBuyNow(mount) {
    if (!dxStateComplete()) { dxErr(mount, 'Velg leveringsdag og tidsvindu først.'); return; }
    var variantInput = document.getElementById('fhp-variant-id');
    var qtyInput = document.getElementById('fhp-qty');
    var variantId = variantInput ? parseInt(variantInput.value, 10) : 0;
    if (!variantId) { dxErr(mount, 'Velg en størrelse først.'); return; }
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    dxErr(mount, null);
    var cta = mount.querySelector('.fh-dx-cta');
    cta.disabled = true;
    cta.textContent = 'Sender deg til betaling...';
    expressPutInCart(variantId, qty).then(function () {
      var params = [];
      if (state.postnr) {
        params.push('checkout[shipping_address][zip]=' + encodeURIComponent(state.postnr));
        params.push('checkout[shipping_address][country]=NO');
      }
      var url = '/checkout' + (params.length ? '?' + params.join('&') : '');
      // Attributtene er alt lagret ved tidsvindu-valg. Re-synk i bakgrunnen,
      // men la ALDRI en treg/feilende /cart/update.js blokkere redirecten.
      var navigated = false;
      function go() { if (navigated) return; navigated = true; window.location.href = url; }
      syncCartAttributes().then(go).catch(go);
      setTimeout(go, 1800);
    }).catch(function (e) {
      cta.disabled = false;
      cta.textContent = 'Til betaling';
      var m = (e && e.fhUser && e.message)
        ? e.message
        : 'Fikk ikke lagt varen i handlekurven. Prøv igjen.';
      dxErr(mount, m);
    });
  }

  // ── Cart widget — Main ────────────────────────────────────────────────────

  var dateOffset = 0;
  var DATES_PER_PAGE = 3;

  function initCartWidget() {
    var widgets = document.querySelectorAll('.fh-dcart');
    if (!widgets.length) return;
    widgets.forEach(function (w) { renderCartWidget(w); });
  }

  function widgetHeader() {
    return '<div class="fh-dcart-header">' +
      '<svg width="22" height="22" fill="none" stroke="white" stroke-width="2" viewBox="0 0 24 24"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>' +
      '<div><h3>Bestilling og levering</h3><p>Levert hjem til døren på leveringsdagen din</p></div>' +
    '</div>';
  }

  // FH 2026-09-07: har kurven en vare som betales ved levering (villaks), og har den
  // abonnementslinjer? Flaggene utledes fra LIVE kurvdata (/cart.js) og oppdateres ved
  // hver kurvmutasjon, fordi fh-cart.js fjerner og endrer linjer UTEN sidelast: det
  // Liquid-rendrede flagget (window.__fhCartBvl / data-fhc-bvl på kurvformen) blir da
  // foreldet og ville låst kunden ute fra kassen, eller motsatt.
  var _cartBvl = null;
  var _cartAbo = null;
  // Sekundærknappen «Betal ved levering» i kurver UTEN villaks (spec v2 punkt 1).
  var BVL_ALLE_PRODUKTER = true;

  function erBvlLinje(item) {
    var p = item && item.properties;
    if (!p) return false;
    var v = p['Betaling'];
    return typeof v === 'string' && v.indexOf('Ved levering') === 0;
  }

  // Kalles med svaret fra /cart.js. Setter begge flaggene og oppdaterer flatene som
  // påstår noe om betaling (infoboks i kurven, trust-linja i sidekortet).
  function lesKurvFlagg(cart) {
    if (!cart || !cart.items) return;
    var bvl = false, abo = false;
    for (var i = 0; i < cart.items.length; i++) {
      if (erBvlLinje(cart.items[i])) bvl = true;
      if (cart.items[i] && cart.items[i].selling_plan_allocation) abo = true;
    }
    _cartBvl = bvl;
    _cartAbo = abo;
    oppdaterBvlFlater();
  }

  function oppdaterBvlFlater() {
    var bvl = cartHasBvl();
    document.querySelectorAll('[data-fhc-bvl-note]').forEach(function (el) { el.hidden = !bvl; });
    document.querySelectorAll('[data-fhc-trust-pay="standard"]').forEach(function (el) { el.hidden = bvl; });
    document.querySelectorAll('[data-fhc-trust-pay="bvl"]').forEach(function (el) { el.hidden = !bvl; });
  }

  function cartHasBvl() {
    // 1) Tag-merket kurvlinje i markupen. Den er den sikreste kilden: merkelappen
    //    følger linja, så den forsvinner når fh-cart.js fjerner kortet, og kommer
    //    tilbake når seksjonen rendres på nytt.
    //    Scopet til kurvformen, så en eventuell kurv-skuff i DOM-en ikke teller med.
    if (document.querySelector('[data-cart-form] [data-fhc-bvl-line]')) return true;
    // 2) Live kurvdata fra siste /cart.js.
    if (_cartBvl !== null) return _cartBvl;
    // 3) Bare før første kurvsvar: det Liquid-rendrede flagget.
    var f = document.querySelector('[data-cart-form]');
    if (f && f.getAttribute('data-fhc-bvl') === 'true') return true;
    return window.__fhCartBvl === true;
  }

  // Abonnement har egen kasse (/pages/start-abonnement). Da skal betal-ved-levering
  // aldri tilbys, ellers ender kunden i en blindvei på bestillingssiden.
  function cartHasAbo() {
    return _cartAbo === true;
  }

  function checkoutBtnHtml(mode) {
    if (mode === 'saving') {
      return '<div class="fh-dcart-action">' +
        '<button type="button" class="fh-dcart-checkout-btn fh-dcart-checkout-btn--saving" disabled>Til kassen</button>' +
      '</div>';
    }
    if (mode === 'ready') {
      // FH 2026-08-21: siste-blikk-bekreftelse paa valgt dag rett ved knappene -
      // Shopify-kassen viser ikke leveringsdagen, saa kunden skal se den her.
      var chosen = '';
      if (state.selectedDate) {
        chosen = '<p class="fh-dcart-chosen" style="margin:0 0 10px;font-size:.9rem;text-align:center;opacity:.9">' +
          'Levering ' + formatDateShort(state.selectedDate) +
          (state.postnr ? ' til ' + esc(state.postnr) : '') + '</p>';
      }
      // FH 2026-09-07: har kurven en vare som betales ved levering (villaks), går HELE
      // bestillingen den veien: ingen Vipps-ekspress og ingen Shopify-kasse.
      if (cartHasBvl() && !cartHasAbo()) {
        return '<div class="fh-dcart-action">' + chosen +
          '<p class="fh-dcart-bvl-note">Villaks avregnes etter vekt. Hele bestillingen betales med Vipps til sjåføren ved levering.</p>' +
          '<button type="button" class="fh-dcart-checkout-btn" data-fh-bvl>Bestill, betal ved levering</button>' +
        '</div>';
      }
      // Kurver uten vare som betales ved levering går som før: Vipps-ekspress og
      // vanlig kasse (primær). Betal ved levering tilbys i tillegg som sekundærknapp
      // (Viktor 6.9.2026: «villaks minst, greit på alt»). BVL_ALLE_PRODUKTER = false
      // skrur sekundærknappen av uten andre endringer. Aldri på abonnement.
      var bvlSekundaer = (BVL_ALLE_PRODUKTER && !cartHasAbo())
        ? '<button type="button" class="fh-dcart-checkout-btn fh-dcart-checkout-btn--bvl" data-fh-bvl>Betal ved levering</button>'
        : '';
      return '<div class="fh-dcart-action">' + chosen +
        '<div class="fh-dcart-vipps" data-fh-vipps' + (vippsReady ? '' : ' hidden') + '>' + vippsBtnHtml('pay') + '</div>' +
        '<button type="button" class="fh-dcart-checkout-btn" data-fh-checkout>Til kassen</button>' +
        bvlSekundaer +
      '</div>';
    }
    return '<div class="fh-dcart-action">' +
      '<button type="button" class="fh-dcart-checkout-btn fh-dcart-checkout-btn--disabled" disabled>Velg levering før du bestiller</button>' +
    '</div>';
  }

  // FH 2026-08-27: pris-linja (#fh-dcart-price-top) og handlingsknappene
  // (.fh-dcart-action) samles i EN felles container. Paa mobil stiles denne
  // containeren som eneste faste bunn-linje (delivery-v2.css) - ingen egne
  // position:fixed-verdier paa hvert element lenger, saa det ikke kan oppstaa
  // sprekk mellom dem uansett hvor hoy .fh-dcart-action sitt innhold er
  // (chosen-dato/Vipps/garanti varierer). Paa desktop (>=750px) har
  // wrapperen ingen positionering, saa den ligger helt normalt i flyten der
  // checkoutBtnHtml() la den fra foer.
  function stickyBottomHtml(mode) {
    return '<div class="fh-dcart-sticky-bottom" id="fh-dcart-sticky-bottom">' +
      '<div class="fh-dcart-price-top" id="fh-dcart-price-top"></div>' +
      checkoutBtnHtml(mode) +
    '</div>';
  }

  // ── Cart: Postnr not yet entered ──────────────────────────────────────────

  function renderCartPostnrPrompt(w) {
    w.innerHTML =
      '<div class="fh-dcart-widget">' +
        widgetHeader() +
        '<div class="fh-dcart-body">' +
          '<div class="fh-dcart-section-divider"></div>' +
          '<p class="fh-dcart-label">Hvor skal vi levere?</p>' +
          '<div class="fh-dcart-postnr-form">' +
            '<input type="text" class="fh-dcart-postnr-input" placeholder="Skriv postnummer" maxlength="4" inputmode="numeric" pattern="[0-9]*">' +
            '<button type="button" class="fh-dcart-postnr-btn">' +
              '<svg class="fh-dcart-postnr-icon" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
              '<span class="fh-dcart-spinner" style="display:none"></span>' +
            '</button>' +
          '</div>' +
          '<p class="fh-dcart-postnr-msg"></p>' +
          stickyBottomHtml(false) +
        '</div>' +
      '</div>';

    updateTopPricing(w);

    var input = w.querySelector('.fh-dcart-postnr-input');
    var btn = w.querySelector('.fh-dcart-postnr-btn');
    var msg = w.querySelector('.fh-dcart-postnr-msg');
    btn.addEventListener('click', function () { doCartCheck(input, msg, w); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') doCartCheck(input, msg, w); });
    // FH 2026-08-02: auto-søk ved fjerde siffer (samme oppførsel som forsiden - sparer et trykk)
    input.addEventListener('input', function () {
      var v = (input.value || '').replace(/\D/g, '');
      if (v.length === 4 && v !== input.dataset.fhSjekket) {
        input.dataset.fhSjekket = v;
        doCartCheck(input, msg, w);
      }
    });
  }

  function setPostnrLoading(w, loading) {
    var input = w.querySelector('.fh-dcart-postnr-input');
    var btn = w.querySelector('.fh-dcart-postnr-btn');
    var icon = w.querySelector('.fh-dcart-postnr-icon');
    var spinner = w.querySelector('.fh-dcart-spinner');
    if (input) { input.disabled = loading; input.classList.toggle('fh-dcart-postnr-input--loading', loading); }
    if (btn) btn.disabled = loading;
    if (icon) icon.style.display = loading ? 'none' : '';
    if (spinner) spinner.style.display = loading ? '' : 'none';
  }

  function showCartCapture(val) {
    var cap = document.querySelector('[data-fhc-capture]');
    if (!cap) return;
    cap.hidden = false;
    var root = cap.querySelector('[data-fhci]');
    if (root) root.dataset.postnr = val;
  }
  function hideCartCapture() {
    var cap = document.querySelector('[data-fhc-capture]');
    if (cap) cap.hidden = true;
  }

  function doCartCheck(input, msg, w) {
    var val = (input.value || '').trim().replace(/\s/g, '').padStart(4, '0');
    if (val.length < 4 || !/^\d{4}$/.test(val)) {
      msg.textContent = 'Skriv inn et gyldig postnummer';
      msg.className = 'fh-dcart-postnr-msg fh-dcart-postnr-msg--err';
      return;
    }

    msg.innerHTML = '<span class="fh-dcart-spinner fh-dcart-spinner--sm"></span> Sjekker postnummer...';
    msg.className = 'fh-dcart-postnr-msg fh-dcart-postnr-msg--loading';
    setPostnrLoading(w, true);

    checkPostnr(val).then(function (data) {
      if (data.available) {
        hideCartCapture();
        state.postnr = val; state.zone = data.zone; state.nextDates = data.next_dates || [];
        if (!state.nextDates.length) {
          msg.textContent = 'Vi har ingen ledige leveringsdager til ' + val + ' akkurat nå';
          msg.className = 'fh-dcart-postnr-msg fh-dcart-postnr-msg--err';
          showCartCapture(val);
          setPostnrLoading(w, false);
          return;
        }
        state.selectedDate = state.nextDates[0] || null; state.selectedSlot = null; state.slots = [];
        saveState();
        var body = w.querySelector('.fh-dcart-body');
        if (body) {
          body.style.transition = 'opacity 0.2s ease';
          body.style.opacity = '0';
          setTimeout(function () {
            renderCartWidget(w);
            var nb = w.querySelector('.fh-dcart-body');
            if (nb) { nb.style.opacity = '0'; nb.style.transition = 'opacity 0.35s ease'; requestAnimationFrame(function () { nb.style.opacity = '1'; }); }
            initProductDelivery();
          }, 200);
        } else {
          renderCartWidget(w); initProductDelivery();
        }
      } else {
        msg.textContent = 'Vi leverer dessverre ikke til ' + val + ' ennå';
        msg.className = 'fh-dcart-postnr-msg fh-dcart-postnr-msg--err';
        showCartCapture(val);
        setPostnrLoading(w, false);
      }
    }).catch(function () {
      msg.textContent = 'Noe gikk galt. Prøv igjen.';
      msg.className = 'fh-dcart-postnr-msg fh-dcart-postnr-msg--err';
      setPostnrLoading(w, false);
    });
  }

  // ── Cart: Full widget (postnr confirmed) ──────────────────────────────────

  var DATE_GAP = 6;

  function buildAllDateCards(dates, selected) {
    var html = '';
    for (var i = 0; i < dates.length; i++) {
      var dateStr = dates[i];
      var sel = (selected === dateStr) ? ' fh-dcart-date--sel' : '';
      var badge = (i === 0) ? '<span class="fh-dcart-badge">Neste</span>' : '';
      html += '<button type="button" class="fh-dcart-date' + sel + '" data-date="' + dateStr + '">' +
        badge +
        '<span class="fh-dcart-date-day">' + dayNameCap(dateStr) + '</span>' +
        '<span class="fh-dcart-date-num">' + dayNum(dateStr) + '</span>' +
        '<span class="fh-dcart-date-month">' + monthName(dateStr) + '</span>' +
      '</button>';
    }
    return html;
  }

  var _sliderCardWidth = 0;

  function calcCardWidth(viewport) {
    var vpWidth = viewport.offsetWidth;
    if (vpWidth <= 0) return 90;
    return Math.floor((vpWidth - (DATES_PER_PAGE - 1) * DATE_GAP) / DATES_PER_PAGE);
  }

  function applyCardWidths(w) {
    var viewport = w.querySelector('.fh-dcart-dates-viewport');
    if (!viewport) return;
    // FIX (2026-09-11): kortene fikk fast 90px fordi calcCardWidth maalte viewporten mens
    // steget/popupen/draweren var display:none (offsetWidth 0). Utsett maalingen til
    // viewporten faktisk er synlig, via IntersectionObserver. Container-agnostisk.
    if (viewport.offsetWidth <= 0) {
      if (typeof IntersectionObserver !== 'undefined' && !viewport._fhWaitVisible) {
        viewport._fhWaitVisible = true;
        var io = new IntersectionObserver(function (entries, obs) {
          if (viewport.offsetWidth > 0) {
            viewport._fhWaitVisible = false;
            obs.disconnect();
            applyCardWidths(w);
            updateArrowVisibility(w);
          }
        });
        io.observe(viewport);
      }
      return;
    }
    _sliderCardWidth = calcCardWidth(viewport);
    var cards = w.querySelectorAll('.fh-dcart-date');
    cards.forEach(function (c) { c.style.width = _sliderCardWidth + 'px'; c.style.minWidth = _sliderCardWidth + 'px'; });
    slideDates(w, _sliderCardWidth);
  }

  function initDateSlider(w) {
    var viewport = w.querySelector('.fh-dcart-dates-viewport');
    if (!viewport) return;

    applyCardWidths(w);
    updateArrowVisibility(w);

    w.querySelector('#fh-date-left').addEventListener('click', function () {
      dateOffset = Math.max(0, dateOffset - 1);
      slideDates(w, _sliderCardWidth);
      updateArrowVisibility(w);
    });
    w.querySelector('#fh-date-right').addEventListener('click', function () {
      dateOffset = Math.min(state.nextDates.length - DATES_PER_PAGE, dateOffset + 1);
      slideDates(w, _sliderCardWidth);
      updateArrowVisibility(w);
    });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { applyCardWidths(w); updateArrowVisibility(w); }, 150);
    });
  }

  function slideDates(w, cardWidth) {
    var track = w.querySelector('.fh-dcart-dates-track');
    if (!track) return;
    var tx = -(dateOffset * (cardWidth + DATE_GAP));
    track.style.transform = 'translateX(' + tx + 'px)';
  }

  function updateArrowVisibility(w) {
    var l = w.querySelector('#fh-date-left');
    var r = w.querySelector('#fh-date-right');
    if (l) { l.style.visibility = dateOffset > 0 ? 'visible' : 'hidden'; }
    if (r) { r.style.visibility = dateOffset + DATES_PER_PAGE < state.nextDates.length ? 'visible' : 'hidden'; }
  }

  function renderCartWidget(w) {
    // Background refresh zone name (fixes stale cached names)
    if (state.postnr && state.zone) {
      checkPostnr(state.postnr).then(function(data) {
        if (data.available && data.zone && data.zone.name !== state.zone.name) {
          state.zone = data.zone;
          saveState();
          var confirm = w.querySelector('.fh-dcart-confirm p');
          if (confirm) confirm.innerHTML = 'Leverer til <strong>' + esc(state.postnr) + ' ' + esc(state.zone.name) + '</strong>';
        }
      }).catch(function() {});
    }
    // Validate cached dates are not stale
    if (state.nextDates && state.nextDates.length > 0 && state.postnr) {
      var _now = new Date();
      var _oslo = new Date(_now.toLocaleString('en-US', {timeZone: 'Europe/Oslo'}));
      var _todayStr = _oslo.getFullYear() + '-' +
        String(_oslo.getMonth()+1).padStart(2,'0') + '-' +
        String(_oslo.getDate()).padStart(2,'0');
      var freshDates = state.nextDates.filter(function(d) { return d > _todayStr; });
      if (freshDates.length < state.nextDates.length ||
          (state.selectedDate && state.selectedDate <= _todayStr)) {
        state.nextDates = freshDates;
        if (state.selectedDate && state.selectedDate <= _todayStr) {
          state.selectedDate = freshDates[0] || null;
          state.selectedSlot = null;
          state.slots = [];
        }
        saveState();
        if (freshDates.length === 0 && state.postnr) {
          checkPostnr(state.postnr).then(function(data) {
            if (data.available) {
              state.zone = data.zone;
              state.nextDates = data.next_dates || [];
              state.selectedDate = state.nextDates[0] || null;
              state.selectedSlot = null;
              state.slots = [];
              saveState();
              renderCartWidget(w);
            }
          });
          renderCartPostnrPrompt(w);
          return;
        }
      }
    }

    if (!state.postnr || !state.zone || !state.nextDates.length) {
      renderCartPostnrPrompt(w);
      return;
    }

    var allDatesHtml = buildAllDateCards(state.nextDates, state.selectedDate);
    var hasFullSelection = state.postnr && state.selectedDate && state.selectedSlot;

    w.innerHTML =
      '<div class="fh-dcart-widget">' +
        widgetHeader() +
        '<div class="fh-dcart-body">' +

          '<div class="fh-dcart-section-divider"></div>' +

          '<div class="fh-dcart-confirm">' +
            '<div class="fh-dcart-check"><svg fill="none" stroke="white" stroke-width="2.5" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg></div>' +
            '<p>Leverer til <strong>' + esc(state.postnr) + ' ' + esc(state.zone.name) + '</strong></p>' +
            '<a class="fh-dcart-change" href="#">Endre</a>' +
          '</div>' +

          '<div class="fh-dcart-date-header">' +
            '<p class="fh-dcart-label">Velg leveringsdag</p>' +
            '<button type="button" class="fh-dcart-cal-btn" id="fh-dcart-cal-btn">' +
              '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>' +
              ' Kalender' +
            '</button>' +
          '</div>' +
          '<div class="fh-dcart-date-row">' +
            '<button type="button" class="fh-dcart-arrow fh-dcart-arrow--left" id="fh-date-left"><svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg></button>' +
            '<div class="fh-dcart-dates-viewport"><div class="fh-dcart-dates-track">' + allDatesHtml + '</div></div>' +
            '<button type="button" class="fh-dcart-arrow fh-dcart-arrow--right" id="fh-date-right"><svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg></button>' +
          '</div>' +

          '<p class="fh-dcart-label">Velg tidsvindu</p>' +
          '<div class="fh-dcart-slots" id="fh-dcart-slots"></div>' +

          '<div class="fh-dcart-cutoff" id="fh-dcart-cutoff"></div>' +

          '<div class="fh-dcart-note-section">' +
            '<textarea class="fh-dcart-note-input" id="fh-dcart-note" placeholder="Leveringsnotat (f.eks. ringeklokke, etasje, portkode...)" rows="2" maxlength="200"></textarea>' +
          '</div>' +

          '<div class="fh-dcart-nothome" id="fh-dcart-nothome">' +
            '<label class="fh-dcart-nothome-toggle">' +
              '<input type="checkbox" id="fh-dcart-nothome-check">' +
              '<span class="fh-dcart-nothome-label">Jeg er ikke hjemme - legg ved døren</span>' +
            '</label>' +
            '<div class="fh-dcart-nothome-panel" id="fh-dcart-nothome-panel" style="display:none">' +
              '<div class="fh-dcart-nothome-warning">' +
                '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>' +
                '<span>Frossen vare - må i fryseren innen 2 timer. Etter levering er ansvaret ditt.</span>' +
              '</div>' +
            '</div>' +
          '</div>' +

          '<div class="fh-dcart-trust">' +
            '<div class="fh-dcart-trust-item">' +
              '<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.362 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>' +
              '<span>Du får SMS med oppdateringer på leveringsdagen</span>' +
            '</div>' +
          '</div>' +

          stickyBottomHtml(hasFullSelection ? 'ready' : false) +

        '</div>' +
      '</div>';

    // ── Bindings ──

    updateTopPricing(w);

    w.querySelectorAll('.fh-dcart-date').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.selectedDate = btn.dataset.date;
        state.selectedSlot = null;
        saveState();
        w.querySelectorAll('.fh-dcart-date').forEach(function (b) { b.classList.remove('fh-dcart-date--sel'); });
        btn.classList.add('fh-dcart-date--sel');
        loadSlots(w);
      });
    });

    initDateSlider(w);

    w.querySelector('.fh-dcart-change').addEventListener('click', function (e) {
      e.preventDefault(); clearState(); renderCartWidget(w);
    });

    if (!window.__fhCalDelegated) {
      window.__fhCalDelegated = true;
      document.addEventListener('click', function (ev) {
        var calTarget = ev.target.closest('#fh-dcart-cal-btn');
        if (!calTarget) return;
        ev.stopPropagation();
        var existing = document.getElementById('fh-cal-popup');
        var ww = calTarget.closest('.fh-dcart');
        if (existing) { closeCalendar(); } else if (ww) { openCalendar(ww); }
      });
    }

    var noteInput = w.querySelector('#fh-dcart-note');
    if (noteInput) {
      noteInput.value = state.deliveryNote || '';
      var noteTimer = null;
      noteInput.addEventListener('input', function () {
        state.deliveryNote = noteInput.value; saveState();
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () { syncCartAttributes(); }, 500);
      });
    }

    var nothomeCheck = w.querySelector('#fh-dcart-nothome-check');
    var nothomePanel = w.querySelector('#fh-dcart-nothome-panel');
    if (nothomeCheck && nothomePanel) {
      nothomeCheck.checked = state.notHome || false;
      nothomePanel.style.display = state.notHome ? 'block' : 'none';
      nothomeCheck.addEventListener('change', function () {
        state.notHome = nothomeCheck.checked;
        nothomePanel.style.display = state.notHome ? 'block' : 'none';
        saveState(); syncCartAttributes();
      });
    }

    if (state.selectedDate) loadSlots(w);
  }

  // ── Calendar popup ─────────────────────────────────────────────────────────

  var calViewMonth = null;
  var calViewYear = null;

  function openCalendar(w) {
    closeCalendar();
    var btn = w.querySelector('#fh-dcart-cal-btn');
    if (!btn) return;

    var now = new Date();
    if (state.selectedDate) {
      var sel = parseDate(state.selectedDate);
      calViewMonth = sel.getMonth();
      calViewYear = sel.getFullYear();
    } else {
      calViewMonth = now.getMonth();
      calViewYear = now.getFullYear();
    }

    var popup = document.createElement('div');
    popup.className = 'fh-cal-popup';
    popup.id = 'fh-cal-popup';
    renderCalendarMonth(popup, w);

    var header = w.querySelector('.fh-dcart-date-header');
    if (header) {
      header.style.position = 'relative';
      header.appendChild(popup);
    }

    requestAnimationFrame(function () { popup.classList.add('fh-cal-popup--open'); });

    setTimeout(function () {
      document.addEventListener('click', calOutsideClick);
      document.addEventListener('keydown', calEscPress);
    }, 0);
  }

  function closeCalendar() {
    var popup = document.getElementById('fh-cal-popup');
    if (popup) {
      popup.classList.remove('fh-cal-popup--open');
      setTimeout(function () { if (popup.parentNode) popup.parentNode.removeChild(popup); }, 150);
    }
    document.removeEventListener('click', calOutsideClick);
    document.removeEventListener('keydown', calEscPress);
  }

  function calOutsideClick(e) {
    var popup = document.getElementById('fh-cal-popup');
    var btn = document.getElementById('fh-dcart-cal-btn');
    if (popup && !popup.contains(e.target) && (!btn || !btn.contains(e.target))) closeCalendar();
  }

  function calEscPress(e) { if (e.key === 'Escape') closeCalendar(); }

  function renderCalendarMonth(popup, w) {
    var availSet = {};
    (state.nextDates || []).forEach(function (d) { availSet[d] = true; });

    var first = new Date(calViewYear, calViewMonth, 1);
    var daysInMonth = new Date(calViewYear, calViewMonth + 1, 0).getDate();
    var startDay = (first.getDay() + 6) % 7;

    var now = new Date();
    var oslo = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Oslo' }));
    var todayStr = oslo.getFullYear() + '-' + String(oslo.getMonth() + 1).padStart(2, '0') + '-' + String(oslo.getDate()).padStart(2, '0');

    var hasAvailBefore = state.nextDates.some(function (d) {
      var p = parseDate(d);
      return p.getFullYear() < calViewYear || (p.getFullYear() === calViewYear && p.getMonth() < calViewMonth);
    });
    var hasAvailAfter = state.nextDates.some(function (d) {
      var p = parseDate(d);
      return p.getFullYear() > calViewYear || (p.getFullYear() === calViewYear && p.getMonth() > calViewMonth);
    });

    var monthLabel = MONTH_NAMES[calViewMonth].charAt(0).toUpperCase() + MONTH_NAMES[calViewMonth].slice(1) + ' ' + calViewYear;
    var dayHeaders = ['Ma', 'Ti', 'On', 'To', 'Fr', 'Lø', 'Sø'];

    var html = '<div class="fh-cal-head">' +
      '<button type="button" class="fh-cal-nav' + (hasAvailBefore ? '' : ' fh-cal-nav--hidden') + '" id="fh-cal-prev">' +
        '<svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>' +
      '</button>' +
      '<span class="fh-cal-title">' + monthLabel + '</span>' +
      '<button type="button" class="fh-cal-nav' + (hasAvailAfter ? '' : ' fh-cal-nav--hidden') + '" id="fh-cal-next">' +
        '<svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg>' +
      '</button>' +
    '</div>';

    html += '<div class="fh-cal-days">';
    dayHeaders.forEach(function (dh) { html += '<span class="fh-cal-dh">' + dh + '</span>'; });

    for (var i = 0; i < startDay; i++) html += '<span class="fh-cal-empty"></span>';

    for (var d = 1; d <= daysInMonth; d++) {
      var dateStr = calViewYear + '-' + String(calViewMonth + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
      var isAvail = !!availSet[dateStr];
      var isSel = state.selectedDate === dateStr;
      var isPast = dateStr <= todayStr;

      var cls = 'fh-cal-day';
      if (isSel) cls += ' fh-cal-day--sel';
      else if (isAvail) cls += ' fh-cal-day--avail';
      else if (isPast) cls += ' fh-cal-day--past';
      else cls += ' fh-cal-day--off';

      if (isAvail || isSel) {
        html += '<button type="button" class="' + cls + '" data-date="' + dateStr + '">' + d + '</button>';
      } else {
        html += '<span class="' + cls + '">' + d + '</span>';
      }
    }
    html += '</div>';

    popup.innerHTML = html;

    popup.querySelector('#fh-cal-prev').addEventListener('click', function (e) {
      e.stopPropagation();
      calViewMonth--;
      if (calViewMonth < 0) { calViewMonth = 11; calViewYear--; }
      renderCalendarMonth(popup, w);
    });

    popup.querySelector('#fh-cal-next').addEventListener('click', function (e) {
      e.stopPropagation();
      calViewMonth++;
      if (calViewMonth > 11) { calViewMonth = 0; calViewYear++; }
      renderCalendarMonth(popup, w);
    });

    popup.querySelectorAll('.fh-cal-day--avail, .fh-cal-day--sel').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var picked = btn.dataset.date;
        state.selectedDate = picked;
        state.selectedSlot = null;
        saveState();

        var idx = state.nextDates.indexOf(picked);
        if (idx >= 0) {
          dateOffset = Math.max(0, Math.min(idx, state.nextDates.length - DATES_PER_PAGE));
        }

        closeCalendar();

        w.querySelectorAll('.fh-dcart-date').forEach(function (b) {
          b.classList.toggle('fh-dcart-date--sel', b.dataset.date === picked);
        });
        slideDates(w, _sliderCardWidth);
        updateArrowVisibility(w);
        loadSlots(w);
      });
    });
  }

  // ── Slots ─────────────────────────────────────────────────────────────────

  function loadSlots(w) {
    var container = w.querySelector('#fh-dcart-slots');
    if (!container || !state.zone || !state.selectedDate) return;

    container.style.opacity = '0.5';
    container.style.pointerEvents = 'none';

    getSlots(state.zone.id, state.selectedDate).then(function (data) {
      container.style.opacity = '1';
      container.style.pointerEvents = '';
      var slots = data.slots || [];
      state.slots = slots;

      if (!slots.length) {
        container.innerHTML = '<p class="fh-dcart-no-slots">Ingen tidsvinduer tilgjengelig</p>';
        return;
      }

      if (!state.selectedSlot) {
        var available = slots.filter(function (s) { return s.available > 0; });
        var recSlot = available.filter(function (s) { return s.recommended; });
        var autoSelect = recSlot.length > 0 ? recSlot[0] : (available.length > 0 ? available[0] : null);
        if (autoSelect) { state.selectedSlot = autoSelect.slot_id; saveState(); }
      }

      container.innerHTML = slots.map(function (s) {
        var sel = (state.selectedSlot === s.slot_id) ? ' fh-dcart-slot--sel' : '';
        var full = s.available === 0 ? ' fh-dcart-slot--full' : '';
        var few = (s.available > 0 && s.available <= 3) ? ' fh-dcart-slot--few' : '';
        var isRec = s.recommended && s.available > 0;
        var rec = isRec ? ' fh-dcart-slot--rec' : '';
        var capText = s.available === 0 ? 'Fullt' : s.available <= 3 ? 'Kun ' + s.available + ' plasser igjen' : s.available + ' plasser igjen';
        var slotCartTotal = getCartTotal();
        var slotFree = slotCartTotal >= 1000;
        var priceText = slotFree
          ? '<span class="fh-dcart-slot-price fh-dcart-slot-price--free">Gratis</span>'
          : '<span class="fh-dcart-slot-price">kr 130</span>';
        var recText = isRec
          ? '<span class="fh-dcart-slot-rec">Anbefalt</span>' +
            (s.recommendation_text ? '<span class="fh-dcart-slot-rec-text">' + esc(s.recommendation_text) + '</span>' : '')
          : '';

        return '<button type="button" class="fh-dcart-slot' + sel + full + few + rec + '" data-slot="' + s.slot_id + '"' + (s.available === 0 ? ' disabled' : '') + '>' +
          '<div class="fh-dcart-slot-radio"></div>' +
          '<div class="fh-dcart-slot-info">' +
            '<span class="fh-dcart-slot-time">' + formatTime(s.start) + ' – ' + formatTime(s.end) + '</span>' +
            '<span class="fh-dcart-slot-cap">' + capText + '</span>' +
          '</div>' +
          '<div class="fh-dcart-slot-right">' + priceText + recText + '</div>' +
        '</button>';
      }).join('');

      container.querySelectorAll('.fh-dcart-slot:not([disabled])').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.selectedSlot = parseInt(btn.dataset.slot, 10);
          saveState();
          container.querySelectorAll('.fh-dcart-slot').forEach(function (b) { b.classList.remove('fh-dcart-slot--sel'); });
          btn.classList.add('fh-dcart-slot--sel');
          updateCutoff(w);
          updateTopPricing(w);
          updateCheckoutBtn(w, 'saving');
          syncCartAttributes().then(function () {
            updateCheckoutBtn(w, 'ready');
          }).catch(function () {
            updateCheckoutBtn(w, 'ready');
          });
        });
      });

      updateCutoff(w);
      updateTopPricing(w);
      updateCheckoutBtn(w);
    }).catch(function (err) {
      if (err === 'stale') return;
      container.style.opacity = '1';
      container.style.pointerEvents = '';
      container.innerHTML = '<p class="fh-dcart-no-slots">Kunne ikke hente tidsvinduer</p>';
    });
  }

  // ── Cutoff ────────────────────────────────────────────────────────────────

  function updateCutoff(w) {
    var el = w.querySelector('#fh-dcart-cutoff');
    if (!el || !state.selectedDate) return;
    var d = parseDate(state.selectedDate);
    d.setDate(d.getDate() - 1);
    var cutoff = DAY_NAMES_CAP[d.getDay()] + ' ' + d.getDate() + '. ' + MONTH_NAMES[d.getMonth()] + ' kl 23:59';
    el.innerHTML =
      '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>' +
      '<p>Bestill innen <strong>' + cutoff + '</strong></p>';
  }

  // ── Top pricing (always visible) ───────────────────────────────────────────

  function updateTopPricing(w) {
    var el = w.querySelector('#fh-dcart-price-top');
    if (!el) return;

    var cartTotal = getCartTotal();
    if (cartTotal === null) cartTotal = 0;

    // FH 2026-08-02: vis faktisk frakt (Gratis / kr 130) og legg frakten inn i totalen
    var fhFree = cartTotal >= 1000;
    var fhFraktCelle = fhFree
      ? '<strong class="fh-dcart-pt-free">Gratis</strong>'
      : '<strong>kr 130</strong>';
    var fhFraktSub = fhFree ? '' : '<div class="fh-dcart-pt-frakt-sub">Gratis frakt over 1 000 kr</div>';
    var fhTotal = fhFree ? cartTotal : cartTotal + 130;

    if (!state.postnr || !state.selectedSlot) {
      el.innerHTML =
        '<div class="fh-dcart-pt">' +
          '<div class="fh-dcart-pt-row"><span>Varer</span><strong>kr ' + formatNumber(cartTotal) + '</strong></div>' +
          '<div class="fh-dcart-pt-row"><span>Frakt</span>' + fhFraktCelle + '</div>' +
          fhFraktSub +
          '<div class="fh-dcart-pt-div"></div>' +
          '<div class="fh-dcart-pt-row fh-dcart-pt-total"><span>Totalt</span><strong>kr ' + formatNumber(fhTotal) + '</strong></div>' +
        '</div>';
      return;
    }

    var slotInfo = '';
    if (state.selectedDate && state.selectedSlot) {
      var slot = state.slots.find(function (s) { return s.slot_id === state.selectedSlot; });
      if (slot) {
        slotInfo =
          '<div class="fh-dcart-pt-delivery-info">' +
            '<span>' + formatDateShort(state.selectedDate) + ', ' + formatTime(slot.start) + '–' + formatTime(slot.end) + '</span>' +
          '</div>';
      }
    }

    el.innerHTML =
      '<div class="fh-dcart-pt">' +
        '<div class="fh-dcart-pt-row"><span>Varer</span><strong>kr ' + formatNumber(cartTotal) + '</strong></div>' +
        '<div class="fh-dcart-pt-row"><span>Frakt</span>' + fhFraktCelle + '</div>' +
        fhFraktSub +
        '<div class="fh-dcart-pt-div"></div>' +
        '<div class="fh-dcart-pt-row fh-dcart-pt-total"><span>Totalt</span><strong>kr ' + formatNumber(fhTotal) + '</strong></div>' +
        '<p class="fh-dcart-pt-mva">Inkl. MVA</p>' +
        slotInfo +
      '</div>';
  }

  // ── Checkout button state ─────────────────────────────────────────────────

  function updateCheckoutBtn(w, mode) {
    var actionDiv = w.querySelector('.fh-dcart-action');
    if (!actionDiv) return;
    if (!mode) {
      mode = (state.postnr && state.selectedDate && state.selectedSlot) ? 'ready' : false;
    }
    actionDiv.innerHTML = checkoutBtnHtml(mode) +
      '<div class="fh-dcart-garanti"><a href="/pages/kvalitetsgaranti">Kvalitetsgaranti</a></div>';
    toggleNativeCheckout(mode === 'ready');
  }

  function toggleNativeCheckout(show) {
    var btns = document.querySelectorAll('.cart__checkout, .cart__buttons__fieldset [name=checkout], .additional-checkout-buttons, .cart__aside [data-checkout-buttons]');
    btns.forEach(function(b) { b.style.display = show ? '' : 'none'; });
  }

  // ── Utilities ─────────────────────────────────────────────────────────────

  var _cachedCartTotal = null;

  var _lastCartFetch = 0;
  var _cartFetchPromise = null;

  function fetchCartTotal() {
    var now = Date.now();
    if (_cartFetchPromise && now - _lastCartFetch < 2000) return _cartFetchPromise;
    _lastCartFetch = now;
    _cartFetchPromise = fetch('/cart.js').then(function (r) {
      if (!r.ok) return _cachedCartTotal;
      return r.json();
    }).then(function (cart) {
      if (cart && cart.total_price !== undefined) {
        _cachedCartTotal = cart.total_price / 100;
        var el = document.querySelector('[data-fh-cart-total]');
        if (el) el.dataset.fhCartTotal = _cachedCartTotal;
      }
      lesKurvFlagg(cart);
      return _cachedCartTotal;
    }).catch(function () {
      return _cachedCartTotal || 0;
    });
    return _cartFetchPromise;
  }

  function getCartTotal() {
    if (_cachedCartTotal !== null) return _cachedCartTotal;
    var el = document.querySelector('[data-fh-cart-total]');
    if (el) return parseFloat(el.dataset.fhCartTotal) || 0;
    return 0;
  }

  // ── Cart-sync: hold widget-pris i takt med kurv-endringer ─────────────────
  // fh-cart.js muterer kurven via XHR (antall/variant/fjern/upsell) og fyrer
  // INGEN event. Widgeten ble derfor staaende med en FORELDET total til siden
  // ble lastet paa nytt. Watcheren under fanger alle kurv-mutasjoner (XHR OG
  // fetch) og frisker opp total + slot-priser umiddelbart. (fiks 2026-06-23)
  var _cartSyncTimer = null;
  function scheduleCartSync() {
    if (_cartSyncTimer) clearTimeout(_cartSyncTimer);
    _cartSyncTimer = setTimeout(syncWidgetToCart, 250);
  }
  function syncWidgetToCart() {
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart || cart.total_price === undefined) return;
      _cachedCartTotal = cart.total_price / 100;
      var totEl = document.querySelector('[data-fh-cart-total]');
      if (totEl) totEl.dataset.fhCartTotal = _cachedCartTotal;
      lesKurvFlagg(cart);
      document.querySelectorAll('.fh-dcart').forEach(function (w) {
        updateTopPricing(w);
        refreshSlotPrices(w);
        updateCheckoutBtn(w);
      });
    }).catch(function () {});
  }
  function refreshSlotPrices(w) {
    var free = getCartTotal() >= 1000;
    w.querySelectorAll('.fh-dcart-slot-price').forEach(function (el) {
      el.className = 'fh-dcart-slot-price' + (free ? ' fh-dcart-slot-price--free' : '');
      el.textContent = free ? 'Gratis' : 'kr 130';
    });
  }
  function isCartMutationReq(url, body) {
    if (!url) return false;
    if (/\/cart\/(change|add|clear)(\.js)?(\?|$)/.test(url)) return true;
    if (/\/cart\/update(\.js)?(\?|$)/.test(url)) {
      // antall/linje 'updates' = ja; widgetens egne attributt-skriv = nei
      return typeof body === 'string' ? body.indexOf('"updates"') !== -1 : true;
    }
    return false;
  }
  var _cartWatchInstalled = false;
  function installCartMutationWatch() {
    if (_cartWatchInstalled) return;
    _cartWatchInstalled = true;
    try {
      var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) { this.__fhMethod = method; this.__fhUrl = url; return XO.apply(this, arguments); };
      XMLHttpRequest.prototype.send = function (body) {
        if ((this.__fhMethod || '').toUpperCase() === 'POST' && isCartMutationReq(this.__fhUrl, body)) {
          this.addEventListener('load', scheduleCartSync);
        }
        return XS.apply(this, arguments);
      };
    } catch (e) {}
    var OF = window.fetch;
    if (OF) {
      window.fetch = function (input, init) {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var body = init && init.body;
        var mut = isCartMutationReq(url, typeof body === 'string' ? body : '');
        var p = OF.apply(this, arguments);
        if (mut) p.then(scheduleCartSync).catch(function () {});
        return p;
      };
    }
  }

  function formatNumber(n) {
    return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function trackEvent(name, params) {
    if (typeof gtag === 'function') {
      gtag('event', name, Object.assign({ event_category: 'levering' }, params || {}));
    }
  }

  // ── Update all ────────────────────────────────────────────────────────────

  function updateAllComponents() {
    initProductDelivery();
    initCartWidget();
  }

  // ── Cart drawer removal ────────────────────────────────────────────────
  // Drawer disabled: visual issues + allows checkout without delivery info.

  function disableCartDrawer() {
    var s = document.createElement('style');
    s.textContent = 'cart-drawer,#cart-drawer,.drawer--cart,.drawer__backdrop{display:none!important;visibility:hidden!important;pointer-events:none!important}' + ' .cart__checkout,.cart__buttons__fieldset [name=checkout],.additional-checkout-buttons,.cart__aside [data-checkout-buttons]{display:none!important}';
    document.head.appendChild(s);

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-toggle="cart-drawer"],[aria-controls="cart-drawer"],.js-drawer-open-cart,a[href="#cart-drawer"]')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = '/cart';
      }
    }, true);

    // Cart drawer buttons redirect to /cart (but normal add-to-cart stays on page)
  }

  // ── Init ──────────────────────────────────────────────────────────────────

  function cleanProductVariants() {
    // Product page: hide single-option selectors, sort multi-option
    if (window.location.pathname.indexOf('/products/') !== -1) {
      var wrappers = document.querySelectorAll('.selector-wrapper');
      wrappers.forEach(function (w) {
        var radios = w.querySelectorAll('input[type="radio"]');
        if (radios.length <= 1) { w.style.display = 'none'; return; }
        var fieldset = w.querySelector('.radio__fieldset');
        if (!fieldset) return;
        var items = Array.from(fieldset.querySelectorAll('.radio__button'));
        if (items.length < 2) return;
        items.sort(function (a, b) {
          var av = parseFloat((a.querySelector('input') || {}).value) || 0;
          var bv = parseFloat((b.querySelector('input') || {}).value) || 0;
          return av - bv;
        });
        items.forEach(function (item) { fieldset.appendChild(item); });
      });
    }
    // Global: fh-pi-chip — chip text comes from Liquid (option1 / option2), keep as-is
    document.querySelectorAll('.fh-pi-chips').forEach(function (container) {
      var chips = Array.from(container.querySelectorAll('.fh-pi-chip'));
      if (chips.length < 2) return;
      chips.sort(function (a, b) {
        return parseFloat(a.getAttribute('data-price') || 0) - parseFloat(b.getAttribute('data-price') || 0);
      });
      chips.forEach(function (c) { container.appendChild(c); });
    });
  }

  function init() {
    if (!document.getElementById('fh-dcart-spinner-css')) {
      var s = document.createElement('style');
      s.id = 'fh-dcart-spinner-css';
      s.textContent =
        '.fh-dcart-checkout-btn--saving{opacity:.45;pointer-events:none;cursor:default;}';
      document.head.appendChild(s);
    }
    disableCartDrawer();
    cleanProductVariants();
    setTimeout(cleanProductVariants, 800);
    setTimeout(cleanProductVariants, 2000);

    if (!API_BASE) {
      var meta = document.querySelector('meta[name="fh-delivery-api"]');
      if (meta) API_BASE = meta.getAttribute('content');
    }
    if (!API_BASE) return;

    var isCartPage = window.location.pathname === '/cart' || window.location.pathname === '/cart/';

    if (isCartPage) {
      var aside = document.querySelector('.cart__aside');
      if (aside) {
        aside.style.minWidth = '0';
        aside.style.overflow = 'hidden';
        var vw = window.innerWidth;
        if (vw >= 1440) aside.style.flex = '0 0 440px';
        else if (vw >= 1200) aside.style.flex = '0 0 400px';
        else if (vw >= 1024) aside.style.flex = '0 0 360px';
      }

      var themePrice = document.querySelector('.cart__price__holder');
      if (themePrice) themePrice.style.display = 'none';

      var zapiet = document.querySelector('#storePickupApp');
      if (zapiet) zapiet.style.display = 'none';
      var zapietWidget = document.querySelector('.zapiet-delivery-widget, [id*="zapiet"]');
      if (zapietWidget) zapietWidget.style.display = 'none';

      var oldInfo = document.querySelector('.fh-delivery-info');
      if (oldInfo) oldInfo.style.display = 'none';

      var oldShipping = document.querySelector('.fh-cart-shipping');
      if (oldShipping) oldShipping.style.display = 'none';

      var themeBtns = document.querySelector('.cart__buttons-wrapper');
      if (themeBtns) themeBtns.style.display = 'none';

      var themeNote = document.querySelector('em.cart__note');
      if (themeNote) themeNote.style.display = 'none';
    }

    initProductDelivery();
    initExpressPay();

    if (isCartPage) {
      fetchCartTotal().then(function () {
        initCartWidget();
      }).catch(function () {
        initCartWidget();
      });

      document.addEventListener('theme:cart:change', syncWidgetToCart);
      installCartMutationWatch();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.FHDelivery = {
    init: init,
    checkPostnr: checkPostnr,
    getState: function () { return state; },
    clearState: clearState,
    refresh: updateAllComponents,
  };


  // ── Pre-fill checkout med postnr fra leveringswidget ───────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-fh-checkout]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('fh-dcart-checkout-btn--saving');
    var postnr = state.postnr || '';
    var params = [];
    if (postnr) {
      params.push('checkout[shipping_address][zip]=' + encodeURIComponent(postnr));
      params.push('checkout[shipping_address][country]=NO');
    }
    var url = '/checkout' + (params.length ? '?' + params.join('&') : '');
    // Attributtene er allerede lagret ved tidsvindu-valg. Re-synk i bakgrunnen,
    // men la ALDRI en treg/feilende /cart/update.js blokkere redirecten.
    // Fallback-timeout garanterer navigasjon (fiks treg/'skjedde ingenting' 2026-06-23).
    var navigated = false;
    function go() { if (navigated) return; navigated = true; window.location.href = url; }
    syncCartAttributes().then(go).catch(go);
    setTimeout(go, 1800);
  });

  // ── Betal ved levering: egen flyt utenom Shopify-kassen ───────────────
  // Attributtene synkes først (samme som kassa-knappen), men en treg
  // /cart/update.js skal aldri blokkere navigasjonen.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fh-bvl]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('fh-dcart-checkout-btn--saving');
    btn.textContent = 'Et øyeblikk…';
    var navigated = false;
    function go() { if (navigated) return; navigated = true; window.location.href = '/pages/betal-ved-levering?kilde=kurv-steg2'; }
    syncCartAttributes().then(go).catch(go);
    setTimeout(go, 1800);
  });

  // ── Vipps ekspress: identitet via Vipps Login, saa prefilt kasse ────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fh-vipps]');
    if (!btn) return;
    e.preventDefault();
    btn.style.opacity = '0.6'; btn.style.pointerEvents = 'none';
    var postnr = state.postnr || '';
    var base = window.__FH_VIPPS_API || API_BASE;
    var url = base + '/api/vipps/start?postnr=' + encodeURIComponent(postnr);
    var navigated = false;
    function go() { if (navigated) return; navigated = true; window.location.href = url; }
    syncCartAttributes().then(go).catch(go);
    setTimeout(go, 1800);
  });

})();